import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { TableState } from '@store/table-store/table.model.ts';
import { UnitReqModel } from '@models/departments-and-units/units.model.ts';

export type HandleClose = () => void;

export interface UnitActionParams {
  data?: UnitReqModel;
  id?: number;
  isActive?: boolean;
  state?: TableState;
  handleClose?: HandleClose;
}

export interface UnitsState extends CallStateMethods {
  callState: CallStateEnum;
  assignedAdmin: any[];
  assignedAdminList: { id: number; title: string; value: string }[];
  getAssignedAdminList: () => void;
  createUnit: (params: UnitActionParams) => void;
  editUnit: (params: UnitActionParams) => void;
  changeStatus: (params: UnitActionParams) => void;
}

interface UnitsStateMethods extends CallStateMethodNames {
  getAssignedAdminList: 'getAssignedAdminList';
  createUnit: 'createUnit';
  editUnit: 'editUnit';
  changeStatus: 'changeStatus';
}

export const UNITS_INITIAL_STATE: Omit<UnitsState, keyof UnitsStateMethods> = {
  callState: CallStateEnum.Init,
  assignedAdmin: [],
  assignedAdminList: []
};
